import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300GetSearchSelectedListModel } from '../vo/kymw1300-get-search-selected-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　次回案内一括設定するサービス
 *
 * @export UpdateNextGuideLumpService
 * @class UpdateNextGuideLump
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class UpdateNextGuideLumpService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof UpdateNextGuideLumpService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof UpdateNextGuideLumpService
   */
  private vo: KYMW1300GetSearchSelectedListModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UpdateNextGuideLumpService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateNextGuideLumpService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        UpdateNextGuideLump: {
          parameter: {
            DispMode: this.vo.dispMode,
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            SellAreaCode: this.vo.sellAreaCode,
            OrderNumQuotaCode: this.vo.orderNumQuotaCode,
            CoopCode: this.vo.coopCode,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            PageNo: this.vo.pageNo,
            BuyerCode: this.vo.buyerCode,
            NextGuideCheck: this.vo.nextGuideCheckFlg,
            Page: this.vo.page,
            SortItem: this.vo.sortItem,
            SortOrder: this.vo.sortOrder,
            OrdrClientCode: this.vo.orderClientCode,
            OrdrClientKanji: this.vo.orderClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateNextGuideLumpService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model>model;
    this.vo = <KYMW1300GetSearchSelectedListModel>vo;
    this.successFunc = successFunc;
    this.send('updateNextGuideLump', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateNextGuideLumpService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
